<template>
    <Poptip placement="left-end" v-model="show">
        <Button type="info">切换状态</Button>
        <div class="mark-poptip" slot="content">
            <Button type="primary" style="background: #333; border: solid 1px #333" @click="ChangeStatus(4)">小黑屋</Button>
            <Button type="primary" style="background: #ababab; border: solid 1px #ababab" @click="ChangeStatus(3)">隐藏</Button>
            <Button type="warning" @click="ChangeStatus(0)">禁用</Button>
            <Button type="success" @click="ChangeStatus(1)">启用</Button>
        </div>
    </Poptip>
</template>

<script>
import { TransTopReq } from '@/api/admin/risk'
export default {
    mounted() {},
    props: ['id', 'platid', 'app_id'],
    data() {
        return { show: false }
    },
    methods: {
        ChangeStatus(type) {
            this.show = false
            let params = {
                mod: 'root',
                platid: this.platid,
                app_id: this.app_id,
                param: {
                    _mod: 'root',
                    _func: 'BatchGameServerRoute',
                    _param: {
                        ids: [this.id],
                        action: type
                    }
                }
            }
            TransTopReq(params).then((res) => {
                this.$emit('getGameServerRouteList')
                this.$Notice.success({
                    desc: '操作成功！'
                })
            })
        }
    }
}
</script>

<style lang="less">
.mark-poptip {
    p {
        text-align: left;
    }
    button {
        margin: 5px;
        width: 80px;
    }
}
.ivu-table-fixed-body {
    overflow: initial;
}
.ivu-poptip-body {
    padding: 4px 16px;
}
</style>
